import * as companyBillService from "../../../../services/companyBill";
import * as settings from "../../../../services/settings";

import {
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Space,
  Spin,
  Tabs,
  Tag,
  Typography,
  notification,
} from "antd";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { CompanyBiller } from "../../../../Components/exportBillers/exportPDF/companyBiller";
import { CompanyBillerInvoice } from "../../../../Components/exportBillers/exportPDF/companyBillerInvoice";
import { CreateImageBill } from "../../../../Components/bill/createImages";
import { CreateOriginPackageTransportationService } from "../../../../Components/bill/originPackageService";
import { convertToDayjs } from "../../../../utils/date";
import permissions from "../../../../../configs/permission";
import { useAccessToken } from "../../../../contexts/AccessTokenContext";
import { usePermission } from "../../../../hooks/usePermission";
import { useTranslation } from "react-i18next";
import { validateCreateBill } from "../../../../Components/validations/validateCreateBill";

const initPage = { limit: 10, page: 1, total: 1 };

function getCostFromServices(it, type) {
  const svc = it?.app_originpackagetransportation?.app_originpackage?.app_originpackageservice ?? [];
  const row = svc.find((s) => s.package_service === type);
  if (row?.service_cost == null || row?.service_cost === "") return 0;
  const raw = row.service_cost;
  if (typeof raw === "object" && raw !== null && typeof raw.toString === "function") {
    const n = Number(raw.toString());
    return Number.isFinite(n) ? n : 0;
  }
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}

export const CompanyBillCreatePage = () => {
  const { t, i18n } = useTranslation("packages", "buttons", "companybill", "common");
  const { hasPermission, isSuperuser } = usePermission();
  const { accessToken } = useAccessToken();
  const hasFetchedRef = useRef(false);
  const [formCompanyBill] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [isCreate, setIsCreate] = useState(false);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const billIdFromUrl = searchParams.get("id");
  const modeFromUrl = searchParams.get("mode");
  const [data, setData] = useState(() => location.state ?? null);
  const { Title } = Typography;
  const { TextArea } = Input;
  const [isHiddenBtnCreate, setIsHiddenBtnCreate] = useState(false);
  const [companybillItem, setCompanyBillItem] = useState();
  const [companyBillImage, setCompanyBillImage] = useState();
  const [api, contextHolder] = notification.useNotification();
  const [validateCreateBillRequired, setValidateBillRequired] = useState({
    fieldBillNo: false,
    filedBillStatus: false,
  });
  const [openBillModal, setOpenBillModal] = useState(false);
  const [openBillModalInvoice, setOpenBillModalInvoice] = useState(false);
  const [billPreview, setBillPreview] = useState(() => location.state?.data ?? {});
  const [pdfVersion, setPdfVersion] = useState(0);
  const [currentBillStatus, setCurrentBillStatus] = useState("");
  const [changeStatusLoading, setChangeStatusLoading] = useState(false);

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const navigation = useNavigate();

  const isValidateBillNo = (_, value) => {
    if (value == "") {
      setValidateBillRequired({
        ...validateCreateBillRequired,
        fieldBillNo: false,
      });
      return Promise.reject();
    }

    setValidateBillRequired({
      ...validateCreateBillRequired,
      fieldBillNo: true,
    });
    return Promise.resolve();
  };

  const isValidateBillStatus = (_, value) => {
    if (value == undefined) {
      setValidateBillRequired({
        ...validateCreateBillRequired,
        filedBillStatus: false,
      });
      return Promise.reject();
    }

    setValidateBillRequired({
      ...validateCreateBillRequired,
      filedBillStatus: true,
    });
    return Promise.resolve();
  };

  // callback นี้ถูก child เรียกหลัง fetch/save เสร็จ
  const handleItemsChange = ({ items, sumTotal, packageTotal, totalPrice }) => {
    // รวมยอด summary จาก items ล่าสุด
    const agg = items.reduce(
      (a, it) => {
        const od = Number(it.od ?? it.total_od ?? getCostFromServices(it, "OD") ?? 0);
        const wc = Number(it.wc ?? it.total_wc ?? getCostFromServices(it, "WC") ?? 0);
        const inn = Number(it.in ?? it.total_in ?? getCostFromServices(it, "IN") ?? 0);
        const ot = Number(it.ot ?? it.total_ot ?? getCostFromServices(it, "OT") ?? 0);
        const dd = Number(it.package_service_dd ?? it.total_dd ?? it.app_destinationpackageservice?.service_cost ?? 0);

        const op = it?.app_originpackagetransportation?.app_originpackage;
        a.total_od += od;
        a.total_wc += wc;
        a.total_in += inn;
        a.total_ot += ot;
        a.total_dd += dd;
        a.package_total_weight += Number(op?.total_weight ?? 0);
        a.package_total_volume += Number(op?.total_volume ?? 0);
        a.package_total_amount += Number(op?.total_count ?? 0);
        a.total_density += Number(it?.density ?? 0);
        return a;
      },
      {
        total_od: 0,
        total_wc: 0,
        total_in: 0,
        total_ot: 0,
        total_dd: 0,
        package_total_weight: 0,
        package_total_volume: 0,
        package_total_amount: 0,
        total_density: 0,
      }
    );

    // อัปเดต billPreview ด้วย reference ใหม่ + สรุปบนหัวข้อที่คำนวณจาก items
    // setBillPreview((prev) => ({
    //   ...prev,
    //   app_companybillitem: [...items], // สำคัญ: ทำสำเนาใหม่
    //   // totals บนหัวข้อสำหรับ MyDocument
    //   total_od: agg.total_od.toFixed(2), // ← จะได้ 99.00 ตาม items
    //   total_wc: agg.total_wc.toFixed(2), // ← 221.00
    //   total_in: agg.total_in.toFixed(2), // ← 331.00
    //   total_ot: agg.total_ot.toFixed(2),
    //   total_dd: agg.total_dd.toFixed(2),
    //   total_density: agg.total_density.toFixed(2),

    //   package_total_weight: agg.package_total_weight.toFixed(2),
    //   package_total_volume: agg.package_total_volume.toFixed(5),
    //   package_total_amount: Number(agg.package_total_amount ?? 0),

    //   // totals การเงิน
    //   sum_total_bill:
    //     Number(sumTotal) +
    //     Number(agg.total_od.toFixed(2)) +
    //     Number(agg.total_wc.toFixed(2)) +
    //     Number(agg.total_in.toFixed(2)) +
    //     Number(agg.total_ot.toFixed(2)) +
    //     Number(agg.total_dd.toFixed(2)), // ถ้าคือนิยาม OD+WC+IN+OT+DD รวมทุกแถว
    //   package_total_bill_amount: Number(packageTotal), // รวม bill_amount (shipping)
    //   total_price:
    //     Number(totalPrice) +
    //     Number(agg.total_od.toFixed(2)) +
    //     Number(agg.total_wc.toFixed(2)) +
    //     Number(agg.total_in.toFixed(2)) +
    //     Number(agg.total_ot.toFixed(2)) +
    //     Number(agg.total_dd.toFixed(2)),

    //   _ts: Date.now(), // เปลี่ยน reference ให้ชัวร์
    // }));

    setPdfVersion((v) => v + 1); // บังคับ remount PDF
  };

  const onOpenBillModal = async () => {
    if (!data?.data?.id) return;
    setOpenBillModal(true);
    const response = await companyBillService.getCompanyBillById(accessToken, data.data.id);
    if (response) {
      setBillPreview(response);
    }
  };

  const onChangeStatus = async () => {
    if (!data?.data?.id) return;
    const nextStatus = currentBillStatus === "PAID" ? "UNPAID" : "PAID";
    setChangeStatusLoading(true);
    try {
      await companyBillService.updateCompanyBillStatus(accessToken, {
        id: data.data.id,
        bill_status: nextStatus,
      });
      setCurrentBillStatus(nextStatus);
      openNotificationWithIcon(
        settings.NotificationType.SUCCESS,
        t("Success", { ns: "common" }),
        t("Update_Success", { ns: "common" })
      );
    } catch (err) {
      console.error("[CompanyBillCreatePage] onChangeStatus: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), message);
    }
    setChangeStatusLoading(false);
  };

  const onSubmit = async () => {
    const values = await formCompanyBill.getFieldValue();

    const { bill_no, note, invoice_date } = values || {};
    const { isValid } = validateCreateBill(values);

    if (isValid) {
      if (!data?.data?.id) {
        setLoading(false);
        return;
      }
      const body = {
        id: data.data.id,
        bill_no: bill_no,
        note: note || "",
        invoice_date: invoice_date,
      };
      setLoading(true);
      try {
        const response = await companyBillService.updateCompanyBill(accessToken, body);
        if (response !== null && response != undefined) {
          openNotificationWithIcon(
            settings.NotificationType.SUCCESS,
            t("Success", { ns: "common" }),
            t("Update_Success", { ns: "common" })
          );
        }
      } catch (err) {
        console.error("[CompanyBillCreatePage] onSubmit: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), message);
      }
    } else {
      openNotificationWithIcon(
        settings.NotificationType.ERROR,
        t("Error", { ns: "common" }),
        t("Please_Check_Input", { ns: "common" })
      );
    }

    setLoading(false);
  };

  const items = [
    {
      title: <span>{"Home"}</span>,
    },
    {
      title: <span>{"Menu"}</span>,
    },
    {
      title: <a href="/bill/companybill">{"Company bill"}</a>,
    },
    {
      title: <a style={{ fontWeight: 600, color: "black" }}>{"Edit company bill"}</a>,
    },
  ];

  const selectStatusBill = [
    { value: "PAID", label: "Paid" },
    { value: "UNPAID", label: "Unpaid" },
  ];

  const setDetailData = (data) => {
    formCompanyBill.setFieldValue("origin_transportation", data.app_origintransportation.container);
    formCompanyBill.setFieldValue("company", data.app_company.company_code);
    formCompanyBill.setFieldValue("bill_no", data.bill_no);
    setCurrentBillStatus(data.bill_status ?? "UNPAID");
    formCompanyBill.setFieldValue("note", data.note);

    if (data.invoice_date !== null && data.invoice_date !== undefined && data.invoice_date !== "") {
      formCompanyBill.setFieldValue("invoice_date", convertToDayjs(data?.invoice_date ?? "", "YYYY-MM-DD HH:mm"));
    }
    formCompanyBill.setFieldValue("invoice_no", data?.invoice_no ?? "-");
    setCompanyBillItem(data.id);
    setCompanyBillImage(data.id);
  };

  const initialItems = data?.data
    ? [
        {
          label: "Package",
          children: (
            <CreateOriginPackageTransportationService
              isCompanyBill={true}
              dataCompanyBill={data.data}
              companyBillItemId={companybillItem}
              onItemsChange={handleItemsChange}
              translations={"companybill"}
            />
          ),
          key: "1",
          disabled: isDisable,
        },
        {
          label: "Slip Transfer",
          children: <CreateImageBill isCompanyBill={true} companyBillItemId={companyBillImage} />,
          key: "2",
          disabled: isDisable,
        },
      ]
    : [];

  const onClickedTab = (data) => {
    setIsHiddenBtnCreate(false);
  };

  useEffect(() => {
    if (!accessToken) return;
    if (data) return;
    if (modeFromUrl !== "edit" || !billIdFromUrl) return;

    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const billRecord = await companyBillService.getCompanyBillById(accessToken, billIdFromUrl);
        if (!cancelled && billRecord) {
          setData({ type: "EDIT", data: billRecord });
        }
      } catch (err) {
        console.error("[CompanyBillCreatePage] fetchByIdFromUrl: ", err);
        const { message } = settings.getErrorMessage(err);
        if (!cancelled) {
          openNotificationWithIcon(settings.NotificationType.ERROR, t("Error", { ns: "common" }), message);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [accessToken, billIdFromUrl, modeFromUrl, data]);

  useEffect(() => {
    const lang = localStorage.getItem("lang");
    if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [i18n]);

  useEffect(() => {
    if (!accessToken || hasFetchedRef.current || !data) return;
    hasFetchedRef.current = true;
    setLoading(false);
    if (data.type === "EDIT") {
      setDetailData(data.data);
      setIsDisable(false);
    }
  }, [accessToken, data]);

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row style={{ overflowX: "auto" }}>
          <Col span={24}>
            <Breadcrumb items={items} />
            <Row Row align="middle" justify="space-between">
              <Col>
                <Title level={2} className="pt-4 pb-2">
                  {t("Title_Edit_Company_Bill", { ns: "companybill" })}
                </Title>
              </Col>
              {data?.type === "EDIT" && (
                <Col>
                  <Space>
                    {hasPermission(permissions.CompanyBill.PRINT_INVOICE) && (
                      <Button type="primary" onClick={() => setOpenBillModalInvoice(true)}>
                        {t("Button_Company_Bill.BTN_Print_Invoice", { ns: "companybill" })}
                      </Button>
                    )}
                    {hasPermission(permissions.CompanyBill.PRINT) && (
                      <Button type="primary" onClick={onOpenBillModal}>
                        {t("Button_Company_Bill.BTN_Print", { ns: "companybill" })}
                      </Button>
                    )}
                  </Space>
                </Col>
              )}
            </Row>
          </Col>
          <Col span={24} style={{ minWidth: 640 }}>
            <Form
              form={formCompanyBill}
              labelAlign="left"
              labelCol={{
                flex: "160px",
              }}
            >
              <Row>
                <Col span={12} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Company_Bill_Table.Table_Origin_Transportation", { ns: "companybill" })}
                    name="origin_transportation"
                    key="origin_transportation"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Input
                      disabled={true}
                      size="default"
                      placeholder={"origin transportation"}
                      style={{ minWidth: 200 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={12} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Company_Bill_Table.Table_Company", { ns: "companybill" })}
                    name="company"
                    key="company"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Input disabled={true} size="default" placeholder={"company"} style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={12} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Company_Bill_Table.Table_Bill_No", { ns: "companybill" })}
                    name="bill_no"
                    key="bill_no"
                    style={{ marginBottom: "1rem" }}
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                      },
                      {
                        validator: isValidateBillNo,
                      },
                    ]}
                    hasFeedback
                  >
                    <Input size="default" placeholder={"bill no"} style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={12} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Company_Bill_Table.Table_Bill_Status", { ns: "companybill" })}
                    style={{ marginBottom: "1rem" }}
                  >
                    <Tag
                      color={currentBillStatus === "PAID" ? "success" : "warning"}
                      style={{ fontSize: 14, padding: "2px 10px" }}
                    >
                      {currentBillStatus === "PAID" ? "Paid" : "Unpaid"}
                    </Tag>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={12} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Company_Bill_Table.Table_Invoice_Date", { ns: "companybill" })}
                    name="invoice_date"
                    key="invoice_date"
                    style={{ marginBottom: "1rem" }}
                  >
                    <DatePicker className="w-full" showTime format={"YYYY-MM-DD HH:mm"} style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={12} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Company_Bill_Table.Table_Invoice_No", { ns: "companybill" })}
                    name="invoice_no"
                    key="invoice_no"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Input disabled={true} size="default" placeholder={"invoice no"} style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={12} style={{ minWidth: 200 }}>
                  <Form.Item label={t("Company_Bill_Table.Table_Note", { ns: "companybill" })} name="note">
                    <TextArea rows={4} style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
          {isHiddenBtnCreate === false ? (
            <Col span={24}>
              <Row align="middle" justify="end" style={{ marginTop: "20px", width: "100%", marginBottom: "20px" }}>
                <Space>
                  {(data?.type === "CREATE" && hasPermission(permissions.CompanyBill.ADD)) ||
                  (data?.type === "EDIT" && hasPermission(permissions.CompanyBill.CHANGE)) ? (
                    <Button type="primary" disabled={false} onClick={onSubmit}>
                      {t("BTN_Save", { ns: "buttons" })}
                    </Button>
                  ) : null}
                  {data?.type === "EDIT" && (hasPermission(permissions.CompanyBill.CHANGE_STATUS) || isSuperuser) && (
                    <Button type="primary" loading={changeStatusLoading} onClick={onChangeStatus}>
                      {t("Button_Company_Bill.BTN_Change_Status", { ns: "companybill" })}
                    </Button>
                  )}
                  <Button
                    type="default"
                    onClick={() => {
                      navigation("/bill/companybill");
                    }}
                  >
                    {t("BTN_Cancel", { ns: "buttons" })}
                  </Button>
                </Space>
              </Row>
            </Col>
          ) : (
            ""
          )}
          <Row align="middle" justify="center">
            <Col span={24}>
              {data?.data ? (
                <Card>
                  <Tabs type="card" items={initialItems} onChange={onClickedTab} />
                </Card>
              ) : null}
            </Col>
          </Row>
        </Row>
      </Spin>
      {billPreview?.app_company ? (
        <>
          <CompanyBiller
            isOpenModal={openBillModal}
            setIsOpenModal={setOpenBillModal}
            data={[{ ...billPreview }]}
            pdfVersion={pdfVersion}
          />
          <CompanyBillerInvoice
            isOpenModal={openBillModalInvoice}
            setIsOpenModal={setOpenBillModalInvoice}
            data={[{ ...billPreview }]}
          />
        </>
      ) : null}
    </>
  );
};
